window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    let isMobile = window.innerWidth < 768;
    window.theme.footerAccordion = new Accordion('.accordion-container', {
      openOnInit: isMobile ? [] : [0],
      showMultiple: true,
    });

    window.theme.footerAccordion = new Accordion('.accordion-container-2', {
      openOnInit: isMobile ? [] : [1],
      showMultiple: true,
    });

    window.theme.footerAccordion = new Accordion('.accordion-container-3', {
      openOnInit: isMobile ? [] : [0, 1],
      showMultiple: true,
    });
  });
});
